import Vue from 'vue';
import VueClickOutSide from './click-outside';

Vue.directive('click-outside', VueClickOutSide);



// WEBPACK FOOTER //
// ./src/directives/index.js